// GA4 Setup
import ReactGA from "react-ga4";
import { api } from "./axios";
import store from "../store/store";

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || "";
if (GA_TRACKING_ID) ReactGA.initialize(GA_TRACKING_ID);

const originalFetch = window.fetch;

window.fetch = function (...args) {
    if (args[0]?.toString().includes("https://www.google-analytics.com/g/collect")) {
        const sidMatch = args[0].toString().match(/sid=([^&]+)/);
        if (sidMatch) {
            setCookie("session_id", sidMatch[1], 1);
        }
    }

    return originalFetch.apply(this, args);
};

// Send recurring GA4 events
setInterval(sendGA4Event, 1800000); // every 30 minutes
sendGA4Event(); // first run

// Cookie Helpers
export function setCookie(name: string, value: string, days: number) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

// GA4 Timer Events
export function sendGA4Event() {
    ReactGA.event({
        category: "User Interaction",
        action: "Timer Event",
        label: "Every 30 Minutes",
        value: 1,
    });
    console.log("GA4 event sent!");
}

// Device Type Detection
export const getDeviceType = (): string => {
    const ua = navigator.userAgent;
    if (/Mobi|Android/i.test(ua)) return "Smartphone";
    if (/Tablet|iPad/i.test(ua)) return "Tablet";
    return "Desktop";
};

// User Interaction Tracker
export const trackUserIntearaction = async (
    eventType: string,
    eventLabel: string,
    eventValue: string,
    payload: any,
    isInGA4 = false,
    isSavetoDB = false
) => {
    if (!GA_TRACKING_ID) return;

    if (isInGA4) {
        ReactGA.event({
            category: "User Interaction",
            action: eventType,
            label: eventLabel,
            value: 1,
        });
    }

    const now = new Date();
    const dateStr = now.toISOString().split("T")[0];
    const timeStr = now.toISOString().split("T")[1].split("Z")[0];

    const sessionStart = Date.now();
    const sessionDate = new Date(sessionStart).toISOString().split("T")[0];
    const sessionTime = new Date(sessionStart).toISOString().split("T")[1].split("Z")[0];
    
    const auth_store = store.getState().auth;
   // const auth_store = useAppSelector((state ) => state.auth);
    const eventPayload = {
        ...payload,
        device: getDeviceType(),
        search_date: dateStr,
        search_time: timeStr,
        session_date: sessionDate,
        session_time: sessionTime,
        clientName: auth_store?.clientName
    };

    if (isSavetoDB) {
        try {
            const res = await api.post("/track-user", eventPayload);
            console.log("Tracked:", res);
        } catch (err) {
            console.error("track-user error", err);
        }
    }
};

// ✅ Export originalFetch only after it's defined correctly
export { originalFetch };
